import { SaleDetailsPage } from './pages/dms/sale-details/sale-details.page';
import { ContactVehiclesModel } from './models/dms/contact.model';

import { Routes, RouterModule } from '@angular/router';

import { AuthGuardService } from './services/auth-guard.service';

import { BrowserModule } from '@angular/platform-browser';

import { NgModule } from '@angular/core';
import { RightsResolver } from './resolvers/rights.resolver';

const routes: Routes = [

	{
		path: '',
		redirectTo: 'splash',
		pathMatch: 'full'
	},
	{
		path: 'login',
		loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
	},
	{
		path: 'authenticate',
		loadChildren: () => import('./pages/authenticate/authenticate.module').then(m => m.AuthenticatePageModule)
	},
	{
		path: 'release-notes',
		loadChildren: () => import('./pages/release-notes/release-notes.module').then(m => m.ReleaseNotesPageModule)
	},
    {
        path: 'reset-password',
        loadChildren: () => import('./pages/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
    },
	{
		path: '',
		canActivateChild: [AuthGuardService],
		resolve: { rights: RightsResolver },
		children: [
			{
				path: '',
				loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
			},
			{
				path: 'home',
				children: [
					{
						path: '',
						loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
					},
				]
			},
			{
				path: 'notifications',
				children: [
					{
						path: '',
						loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsPageModule),
					},
					{
						path: ':id',
						loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsPageModule),
					},
				]
			},
			{
				path: 'vehicles',
				children: [
					{
						path: '',
						// loadChildren: () => import('./pages/dms/vehicles/vehicles.module').then(m => m.VehiclesPageModule),
						loadChildren: () => import('./pages/dms/vehicles-search/vehicles-search.module').then(m => m.VehiclesSearchPageModule),
					},
					{
						path: 'search',
						children: [
							{
								path: '',
								loadChildren: () => import('./pages/dms/vehicles-search/vehicles-search.module').then(m => m.VehiclesSearchPageModule),
							},
							{
								path: ':v',
								loadChildren: () => import('./pages/dms/vehicles-search/vehicles-search.module').then(m => m.VehiclesSearchPageModule),
							}
						]
					},
					{
						path: 'view',
						children: [
							{
								path: ':view',
								loadChildren: () => import('./pages/dms/vehicles-view/vehicles-view.module').then(m => m.VehiclesViewPageModule),
							}
						]
					},
					{
						path: ':id',
						loadChildren: () => import('./pages/dms/vehicle/vehicle.module').then(m => m.VehiclePageModule),
					},
					{
						path: 'stock/:stockno',
						loadChildren: () => import('./pages/dms/vehicle/vehicle.module').then(m => m.VehiclePageModule),
					},
					{
						path: ':id/details/:t',
						loadChildren: () => import('./pages/dms/vehicle-details/vehicle-details.module').then(m => m.VehicleDetailsPageModule),
					},
					{
						path: ':id/details/:t/:s/:r',
						loadChildren: () => import('./pages/dms/vehicle-details/vehicle-details.module').then(m => m.VehicleDetailsPageModule),
					},
					{
						path: ':id/details',
						loadChildren: () => import('./pages/dms/vehicle-details/vehicle-details.module').then(m => m.VehicleDetailsPageModule),
					},
                    {
                        path: ':id/copy',
                        loadChildren: () => import('./pages/dms/vehicle-copy/vehicle-copy.module').then( m => m.VehicleCopyPageModule)
                    },
					{
						path: ':id/cost-breakdown',
						loadChildren: () => import('./pages/dms/vehicle-cost-breakdown/vehicle-cost-breakdown.module').then( m => m.VehicleCostBreakdownPageModule)
					},	
					{
						path: ':vehicleId/expense/:id',
						loadChildren: () => import('./pages/dms/vehicle-expense/vehicle-expense.module').then( m => m.VehicleExpensePageModule)
					},	
					{
						path: ':id/activities',
						loadChildren: () => import('./pages/dms/vehicle-activities/vehicle-activities.module').then(m => m.VehicleActivitiesPageModule),
					},
					{
						path: ':id/activities/:t',
						loadChildren: () => import('./pages/dms/vehicle-activities/vehicle-activities.module').then(m => m.VehicleActivitiesPageModule),
					},
					{
						path: ':vehicleId/activities/:id/:activityType',
						loadChildren: () => import('./pages/dms/opportunity-activity/opportunity-activity.module').then(m => m.OpportunityActivityPageModule),
					},
					{
						path: ':id/opportunities',
						loadChildren: () => import('./pages/dms/vehicle-opportunities/vehicle-opportunities.module').then(m => m.VehicleOpportunitiesPageModule),
					},
					{
						path: ':id/opportunities/:t',
						loadChildren: () => import('./pages/dms/vehicle-opportunities/vehicle-opportunities.module').then(m => m.VehicleOpportunitiesPageModule),
					},
					{
						path: ':id/images',
						loadChildren: () => import('./pages/dms/vehicle-images/vehicle-images.module').then(m => m.VehicleImagesPageModule),
					},
					{
						path: ':id/images/:t',
						loadChildren: () => import('./pages/dms/vehicle-images/vehicle-images.module').then(m => m.VehicleImagesPageModule),
					},
					{
						path: ':id/purchase-orders',
						loadChildren: () => import('./pages/dms/purchase-orders/purchase-orders.module').then(m => m.PurchaseOrdersPageModule),
					},
                    {
                        path: ':id/expenses',
                        loadChildren: () => import('./pages/dms/vehicle-expenses/vehicle-expenses.module').then( m => m.VehicleExpensesPageModule)
                    },
					{
						path: ':id/documents/:stockno',
						loadChildren: () => import('./pages/dms/vehicle-documents/vehicle-documents.module').then(m => m.VehicleDocumentsPageModule)
					},
					{
						path: ':vehicle/activity/:v',
						loadChildren: () => import('./pages/dms/activity/activity.module').then(m => m.ActivityPageModule),
					},
					{
						path: ':id/tasks',
						loadChildren: () => import('./pages/dms/vehicle-tasks/vehicle-tasks.module').then( m => m.VehicleTasksPageModule)
					},
					{
						path: ':id/:t',
						loadChildren: () => import('./pages/dms/vehicle/vehicle.module').then(m => m.VehiclePageModule),
					},
				]
			},
			{
				path: 'opportunities',
				children: [
					{
						path: '',
						// loadChildren: () => import('./pages/dms/opportunities/opportunities.module').then(m => m.OpportunitiesPageModule),
						loadChildren: () => import('./pages/dms/opportunities-search/opportunities-search.module').then(m => m.OpportunitiesSearchPageModule),
					},
					{
						path: 'search',
						loadChildren: () => import('./pages/dms/opportunities-search/opportunities-search.module').then(m => m.OpportunitiesSearchPageModule),
					},
					{
						path: 'view',
						children: [
							{
								path: ':view',
								loadChildren: () => import('./pages/dms/opportunities-view/opportunities-view.module').then(m => m.OpportunitiesViewPageModule),
							}
						]
					},
					{
						path: ':id',
						loadChildren: () => import('./pages/dms/opportunity/opportunity.module').then(m => m.OpportunityPageModule),
					},
					{
						path: ':id/details',
						loadChildren: () => import('./pages/dms/opportunity-details/opportunity-details.module').then(m => m.OpportunityDetailsPageModule),
					},
					{
						path: ':id/opportunity-sale',
						loadChildren: () => import('./pages/dms/opportunity-sale/opportunity-sale.module').then( m => m.OpportunitySalePageModule)
					  },
					{
						path: ':id/details/:t',
						loadChildren: () => import('./pages/dms/opportunity-details/opportunity-details.module').then(m => m.OpportunityDetailsPageModule),
					},
					{
						path: ':id/activities',
						loadChildren: () => import('./pages/dms/opportunity-activities/opportunity-activities.module').then(m => m.OpportunityActivitiesPageModule),
					},
					{
						path: ':opportunityId/activities/:id/:activityType',
						loadChildren: () => import('./pages/dms/opportunity-activity/opportunity-activity.module').then(m => m.OpportunityActivityPageModule),
					},
					{
						path: ':opportunityId/activities/:id',
						loadChildren: () => import('./pages/dms/opportunity-activity/opportunity-activity.module').then(m => m.OpportunityActivityPageModule),
					},
					{
						path: ':opportunity/activity/:v',
						loadChildren: () => import('./pages/dms/activity/activity.module').then(m => m.ActivityPageModule),
					},
					{
						path: 'activities',
						children: [
							{
								path: 'new',
								loadChildren: () => import('./pages/dms/activity/activity.module').then(m => m.ActivityPageModule),
							},
							{
								path: ':id',
								loadChildren: () => import('./pages/dms/opportunity-activity/opportunity-activity.module').then(m => m.OpportunityActivityPageModule),
							},
							{
								path: ':id/:activityType',
								loadChildren: () => import('./pages/dms/opportunity-activity/opportunity-activity.module').then(m => m.OpportunityActivityPageModule),
							},
						]
					},
					{
						path: ':id/documents/:stockno',
						loadChildren: () => import('./pages/dms/opportunity-documents/opportunity-documents.module').then(m => m.OpportunityDocumentsPageModule)
					},
				]
			},
			{
				path: 'contacts',
				children: [
					{
						path: '',
						// loadChildren: () => import('./pages/dms/contacts/contacts.module').then(m => m.ContactsPageModule),
						loadChildren: () => import('./pages/dms/contacts-search/contacts-search.module').then(m => m.ContactsSearchPageModule),
					},
					{
						path: 'search',
						loadChildren: () => import('./pages/dms/contacts-search/contacts-search.module').then(m => m.ContactsSearchPageModule),
					},
                    {
                        path: 'merge',
                        loadChildren: () => import('./pages/dms/contact-merge/contact-merge.module').then(m => m.ContactMergePageModule)
                    },
					{
						path: ':id',
						loadChildren: () => import('./pages/dms/contact/contact.module').then(m => m.ContactPageModule),
					},
					{
						path: ':id/details',
						loadChildren: () => import('./pages/dms/contact-details/contact-details.module').then(m => m.ContactDetailsPageModule),
					},
					{
						path: ':id/details/:t',
						loadChildren: () => import('./pages/dms/contact-details/contact-details.module').then(m => m.ContactDetailsPageModule),
					},
					{
						path: ':id/opportunities',
						loadChildren: () => import('./pages/dms/contact-opportunities/contact-opportunities.module').then(m => m.ContactOpportunitiesPageModule),
					},
					{
						path: ':customerId/activities/:id/:activityType',
						loadChildren: () => import('./pages/dms/opportunity-activity/opportunity-activity.module').then(m => m.OpportunityActivityPageModule),
					},
					{
						path: ':id/documents',
						loadChildren: () => import('./pages/dms/contact-documents/contact-documents.module').then(m => m.ContactDocumentsPageModule)
					},
					{
						path: ':id/sales',
						loadChildren: () => import('./pages/dms/contact-sales/contact-sales.module').then(m => m.ContactSalesPageModule)
					},
					{
						path: ':id/vehicles',
						loadChildren: () => import('./pages/dms/contact-vehicles/contact-vehicles.module').then(m => m.ContactVehiclesPageModule)
					},
					{
						path: ':id/tasks',
						loadChildren: () => import('./pages/dms/contact-tasks/contact-tasks.module').then(m => m.ContactTasksPageModule)
					},
					{
						path: ':contact/activity',
						loadChildren: () => import('./pages/dms/activity/activity.module').then(m => m.ActivityPageModule),
					},
				]
			},

			{
				path: 'quote',
				children: [
					{
						path: ':id',
						loadChildren: () => import('./pages/dms/quote/quote.module').then(m => m.QuotePageModule),
					},
                    {
						path: ':id/details',
                        loadChildren: () => import('./pages/dms/quote-details/quote-details.module').then( m => m.QuoteDetailsPageModule)
					},
				]
			},
			{
				path: 'sales',
				children: [
					{
						path: '',
						// loadChildren: () => import('./pages/dms/sales/sales.module').then(m => m.SalesPageModule),
						loadChildren: () => import('./pages/dms/sales-search/sales-search.module').then(m => m.SalesSearchPageModule),
					},
					{
						path: 'search',
						loadChildren: () => import('./pages/dms/sales-search/sales-search.module').then(m => m.SalesSearchPageModule),
					},
					{
						path: 'view',
						children: [
							{
								path: ':view',
								loadChildren: () => import('./pages/dms/sales-view/sales-view.module').then(m => m.SalesViewPageModule),
							}
						]
					},
					{
						path: ':id',
						loadChildren: () => import('./pages/dms/sale/sale.module').then(m => m.SalePageModule),
					},
					{
						path: ':id/details',
						loadChildren: () => import('./pages/dms/sale-details/sale-details.module').then(m => m.SaleDetailsPageModule),
					},
					{
						path: ':id/documents/:t',
						loadChildren: () => import('./pages/dms/sale-documents/sale-documents.module').then(m => m.SaleDocumentsPageModule)
					},
					{
						path: ':id/tasks',
						loadChildren: () => import('./pages/dms/sale-tasks/sale-tasks.module').then( m => m.SaleTasksPageModule)
					},
                    {
                        path: ':id/workflow/:t',
                        loadChildren: () => import('./pages/dms/workflow-wizard/workflow-wizard.module').then( m => m.WorkflowWizardPageModule)
                    },
				]
			},
			{
				path: 'finance-application',
				children: [
					{
						path: ':id',
						loadChildren: () => import('./pages/dms/finance-application/finance-application.module').then(m => m.FinanceApplicationPageModule),
					},
                    {
						path: ':id/details',
                        loadChildren: () => import('./pages/dms/finance-application-details/finance-application-details.module').then( m => m.FinanceApplicationDetailsPageModule)
					},
                    
				]
			},
			{
				path: 'finance-calculator',
				children: [
					{
						path: ':id',
						loadChildren: () => import('./pages/dms/finance-calculator/finance-calculator.module').then(m => m.FinanceCalculatorPageModule),
					}
				]
			},
			{
				path: 'exports', 
                children: [
                    {
                        path: '',
                        loadChildren: () => import('./pages/dms/export/export.module').then(m => m.ExportPageModule),
                    },
                    {
                        path: ':id/settings',
                        loadChildren: () => import('./pages/dms/export-settings/export-settings.module').then( m => m.ExportSettingsPageModule)
                    },
                    {
                        path: ':id/settings/details',
                        loadChildren: () => import('./pages/dms/export-settings-details/export-settings-details.module').then( m => m.ExportSettingsDetailsPageModule)
                    },
                    {
                        path: ':id/settings/dealership-limits',
                        loadChildren: () => import('./pages/dms/export-settings-dealership-limits/export-settings-dealership-limits.module').then( m => m.ExportSettingsDealershipLimitsPageModule)
                    },
                ]                
			},
			{
				path: 'reports',
				children: [
					{
						path: '',
						loadChildren: () => import('./pages/dms/reports/reports.module').then(m => m.ReportsPageModule),
					},
					{
						path: ':id',
						loadChildren: () => import('./pages/dms/report/report.module').then(m => m.ReportPageModule)
					}
				]
			},
			{
				path: 'purchase-order',
				children: [
					{
						path: ':id',
						loadChildren: () => import('./pages/dms/purchase-order/purchase-order.module').then(m => m.PurchaseOrderPageModule),
					},
					{
						path: ':id/:vehicleId',
						loadChildren: () => import('./pages/dms/purchase-order/purchase-order.module').then(m => m.PurchaseOrderPageModule),
					},
				]
			},
			{ path: 'contacts-search', loadChildren: () => import('./pages/dms/contacts-search/contacts-search.module').then(m => m.ContactsSearchPageModule) },
			{ path: 'user', loadChildren: () => import('./pages/user/user.module').then(m => m.UserPageModule) },
			{ path: 'quote', loadChildren: () => import('./pages/dms/quote/quote.module').then(m => m.QuotePageModule) },
			{ path: 'barcode', loadChildren: () => import('./pages/dms/barcode/barcode.module').then(m => m.BarcodePageModule) },
			{ path: 'finance-calculator', loadChildren: () => import('./pages/dms/finance-calculator/finance-calculator.module').then(m => m.FinanceCalculatorPageModule) },
			{
				path: 'carcheck',
				loadChildren: () => import('./pages/carcheck/carcheck.module').then(m => m.CarcheckPageModule)
			},
			{
				path: 'wholesale',
				loadChildren: () => import('./pages/wholesale/wholesale.module').then(m => m.WholesalePageModule)
			},
			{
				path: 'finance',
				pathMatch: 'prefix',
				children: [
					{
						path: '',
						redirectTo: 'application',
						pathMatch: 'prefix',
					},
					{
						path: 'application',
						loadChildren: () => import('./pages/finance-central/application/application.module').then(m => m.ApplicationPageModule)
					},
					{
						path: 'portal',
						loadChildren: () => import('./pages/finance-central/portal/portal.module').then(m => m.PortalPageModule)
					},
				]
			},
			{
				path: 'dashboard',
				children: [
					{
						path: '',
						loadChildren: () => import('./pages/dms/dashboard/dashboard.module').then(m => m.DashboardPageModule),
					}
				]
			},
			{
                path: 'website-admin',
                loadChildren: () => import('./pages/website-admin/website-admin-pages.module').then(m => m.WebsiteAdminPagesModule)
            },
			{
				path: 'tools',
				children: [
					{
						path: '',
						redirectTo: 'tasks',
						pathMatch: 'prefix',
					},
					{
						path: 'tasks',
						loadChildren: () => import('./pages/dms/tasks/tasks.module').then(m => m.TasksPageModule),
					},
					{
						path: 'dealership-documents',
						loadChildren: () => import('./pages/dms/dealership-documents/dealership-documents.module').then( m => m.DealershipDocumentsPageModule)
					},
                    {
                        path: 'money-outstanding',
                        loadChildren: () => import('./pages/dms/money-outstanding/money-outstanding.module').then( m => m.MoneyOutstandingPageModule)
                    },
                    {
                        path: 'system-events',
                        loadChildren: () => import('./pages/dms/system-events/system-events.module').then( m => m.SystemEventsPageModule)
                    },
                    {
                        path: 'run-export',
                        loadChildren: () => import('./pages/dms/run-export/run-export.module').then(m => m.RunExportPageModule)
                    },
                    {
                        path: 'bulk-update',
                        loadChildren: () => import('./pages/dms/bulk-update/bulk-update.module').then( m => m.BulkUpdatePageModule)
                    },
				]
			},
            {
				path: 'accounting',
				children: [
					{
						path: '',
						redirectTo: 'purchase-orders',
						pathMatch: 'prefix',
					},
                    {
						path: 'purchase-orders',
						loadChildren: () => import('./pages/dms/purchase-orders/purchase-orders.module').then(m => m.PurchaseOrdersPageModule),
					},
                    {
                        path: 'product-sale-invoices',
                        children: [
                            {
                                path: '',
                                loadChildren: () => import('./pages/dms/product-sale-invoices/product-sale-invoices.module').then( m => m.ProductSaleInvoicesPageModule)
                            },
                            {
                                path: ':id',
                                loadChildren: () => import('./pages/dms/product-sale-invoice/product-sale-invoice.module').then( m => m.ProductSaleInvoicePageModule)
                            },
                        ]
                    },

				]
			},
            {
                path: 'email',
                loadChildren: () => import('./pages/dms/email/email.module').then( m => m.EmailPageModule)
            },
            {
                path: 'sms',
                loadChildren: () => import('./pages/dms/sms/sms.module').then( m => m.SmsPageModule)
            },
            
			// { path: 'wholesale-vehicles', loadChildren: () => import('./pages/dms/wholesale/wholesale-vehicles/wholesale-vehicles.module').then( m => m.WholesaleVehiclesPageModule) },
		]
	},
	// { path: 'logout', loadChildren: () => import('./pages/logout/logout.module').then( m => m.LogoutPageModule) },
	{ path: 'help', loadChildren: () => import('./pages/help/help.module').then(m => m.HelpPageModule) },
	{ path: 'help/about', loadChildren: () => import('./pages/about/about.module').then(m => m.AboutPageModule) },
	{ path: 'about', loadChildren: () => import('./pages/about/about.module').then(m => m.AboutPageModule) },
	{ path: 'splash', loadChildren: () => import('./pages/splash/splash.module').then(m => m.SplashPageModule) },
	{
		path: 'autoattendant',
		loadChildren: () => import('./pages/autoattendant/autoattendant.module').then(m => m.AutoattendantPageModule)
	},
	{
		path: 'buyerscore',
		loadChildren: () => import('./pages/buyerscore/buyerscore.module').then(m => m.BuyerscorePageModule)
	},
	{
		path: 'vxsplash',
		loadChildren: () => import('./pages/wholesale/wholesale-splash/wholesale-splash.module').then(m => m.WholesaleSplashPageModule)
	},
    {
        path: 'dms/splash',
        loadChildren: () => import('./pages/dms/dms-splash/dms-splash.module').then( m => m.DmsSplashPageModule)
    },
	//Wild Card Route for 404 request
	{
		path: '**',
		pathMatch: 'full',
		loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundPageModule)
	},
	{
		path: 'not-found',
		loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundPageModule)
	},
	{
		path: 'dashboard',
		loadChildren: () => import('./pages/dms/dashboard/dashboard.module').then(m => m.DashboardPageModule)
	},
	{
		path: 'opportunity-documents',
		loadChildren: () => import('./pages/dms/opportunity-documents/opportunity-documents.module').then(m => m.OpportunityDocumentsPageModule)
	},






];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
